import React, {useEffect} from 'react'
import SarasSearchAC from '../../../../library/input/autocomplete/SarasSearchAC'
import { getSearchFieldsMatchingParam, getSearchFieldsAll, getSearchFieldSourceByDataType, buildSearchCriteria } from './DocSCFunctions'

const DocSearchCriteria = (props) => {
    const { viewData, addSearchCriteria, currentGroupKey, onCriteriaAction } = props;

    const [scanCount, setScanCount] = React.useState(0);
    const inputRef = React.useRef();
    const scanCountRef = React.useRef();

    // console.log("field list 1", currentGroupKey, Object.values(viewData.childViews.fieldView.viewRows));
    scanCountRef.current = scanCount;

    let initialiseScanner = function() {
            document.addEventListener('onScan', onScan, true);

        return function () {
            document.removeEventListener('onScan', onScan, true);
        }
    }

    useEffect(initialiseScanner, []);

    const inputHaveFocus = () =>{
        if (inputRef && document.activeElement === inputRef.current) {
            return true;
        }

        return false;
    }

    const onScan =  (e) => {
        // console.log("scan event captured 1", e.detail.msg);
        //add the selected criteria to scList list
        if (e.detail.msg.length === 0) return;

        if(!e.detail.haveMultipleCapture || inputHaveFocus()){
            let fieldKey = null;

            //get the first available scanner compatible field
            let list = getSearchFieldSourceByDataType("scan", Object.values(viewData.childViews.fieldView.viewRows));

            if(list && list.length > 0){
                fieldKey = list[0].rowKey;
                
                if (!fieldKey) return;

                let newCriteria = buildSearchCriteria(null, fieldKey, "", e.detail.msg, "", viewData.childViews.fieldView.viewRows);

                if (addSearchCriteria && newCriteria) addSearchCriteria(newCriteria);

                setScanCount(scanCountRef.current + 1);
            }
        }
    }

    const onSelectField = (sp, fieldKey) => {
        // console.log("criteria selected", fieldKey, searchParam, scList);
        //add the selected criteria to scList list
        if (sp.length === 0) return;
        let newCriteria = buildSearchCriteria(null, fieldKey, "", sp, "", viewData.childViews.fieldView.viewRows);

        if (addSearchCriteria && newCriteria) addSearchCriteria(newCriteria);

        // setSearchParam("");
    }

    const onSearchFieldsRequested = () => {
        // console.log("field list 3", currentGroupKey, Object.values(viewData.childViews.fieldView.viewRows));
        //return all fields
        return getSearchFieldsAll(Object.values(viewData.childViews.fieldView.viewRows));
    }

    const onSearchParamChange = (sp) => {
        // console.log("searching for matching fields", sp);
        // setSearchParam(sp);

        //return the matching fields for the given search param value
        return getSearchFieldsMatchingParam(sp, Object.values(viewData.childViews.fieldView.viewRows));
    }

    const haveDateFieldFilter = () => {
        let list = getSearchFieldSourceByDataType("datetime", Object.values(viewData.childViews.fieldView.viewRows));

        return (list && list.length > 0);
    }

    const onFilterFieldClicked = (anchorRef, action, fieldKey) => {
        if (action === "action-select-date") {
            let list = getSearchFieldSourceByDataType("datetime", Object.values(viewData.childViews.fieldView.viewRows));

            if (list && list.length > 0) {
                //open date picker
                // console.log("date field clicked", list[0]);
                if (onCriteriaAction) onCriteriaAction(anchorRef, list[0].rowKey, action);
            }
        }
        else {
            //other actions if any
            if (onCriteriaAction) onCriteriaAction(anchorRef, fieldKey, action);
        }
    }

    return (
        <div style={{ display: 'inline-block' }} className="frmSearchCriteria">
            <div className="frmSearch">
                <div className="uiSearchInput uiFlexBox3">
                    <SarasSearchAC 
                        key={currentGroupKey}
                        currentGroupKey={currentGroupKey}
                        inputRef={inputRef}
                        onSearchParamChange={onSearchParamChange} 
                        onSearchFieldsRequested={onSearchFieldsRequested}
                        haveDateFieldFilter={haveDateFieldFilter}
                        onSelection={onSelectField}
                        resetSearchParam={scanCount} 
                        onCriteriaAction={onFilterFieldClicked} />
                </div>
            </div>
        </div>
    )
}

export default DocSearchCriteria;
